/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Expiration_1monthInputs */

const he_notifications_expiration_1month = /** @type {(inputs: Notifications_Expiration_1monthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חודש`)
};

const en_notifications_expiration_1month = /** @type {(inputs: Notifications_Expiration_1monthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

/**
* | output |
* | --- |
* | "1 Month" |
*
* @param {Notifications_Expiration_1monthInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_expiration_1month = /** @type {((inputs?: Notifications_Expiration_1monthInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Expiration_1monthInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_expiration_1month(inputs)
	return en_notifications_expiration_1month(inputs)
});